export const NOT_FINISHED_QUEUE_STATUSES = [
	'recall',
	'no_response',
	'shift',
	'new',
	'to_confirm',
];
